import { render, staticRenderFns } from "./EduList.vue?vue&type=template&id=fef0ed4a&scoped=true&"
import script from "./EduList.vue?vue&type=script&lang=js&"
export * from "./EduList.vue?vue&type=script&lang=js&"
import style0 from "./EduList.vue?vue&type=style&index=0&id=fef0ed4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef0ed4a",
  null
  
)

export default component.exports